import React from 'react';

export default function Courses() {
  return (
    <div>
      <div className='page'>
        <div className='about_Container'>
          <div className='box1'>
            <h1 className='pagetitle'>my Programs</h1>
            <div className='discription'>Your dedicated personal trainer, committed to transforming lives through fitness, one rep at a time.</div>
            <div className='button'>Workout with me</div>
          </div>
          <div className='box2'>
            <img className='models2' src='/images/perple-girl.jpg' alt='Models2' />
            <img className='models3' src='/images/pretty-hispanic-young-woman-sitting-waiting-her-gym-class.jpg' alt='Models2' />
          </div>
        </div>
        <div className='courseContainer'>
          <div className='pagetitle'>here's What we have for you</div>
          <div className='coursescrollBox'>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/gym-8108016_1280.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Strength Training</h3>
                <p className='coursecardDetails'>Unleash your inner powerhouse with our Strength Training program—designed to sculpt muscle, 
                  boost metabolism, and ignite confidence. Whether you're a beginner or a seasoned lifter, our expert coaches tailor each session 
                  to your goals, ensuring safe, progressive overload that delivers real results.</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/training-828741_1280.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Outdoor Functional Training</h3>
                <p className='coursecardDetails'>Train where life happens—outside. Our Outdoor Functional Training sessions use natural terrain, 
                  dynamic movements, and real-world challenges to build strength, agility, and endurance. From tire flips to hill sprints, every 
                  workout is a celebration of grit and growth. Fresh air, fresh perspective, and a tribe that pushes you to your best</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/running-78192_1280.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Running</h3>
                <p className='coursecardDetails'>Run for speed, run for stamina, run for sanity. Our Running program caters to all levels—from 
                  couch-to-5K beginners to marathon veterans. With expert guidance on technique, pacing, and recovery, you'll build cardiovascular 
                  health, mental resilience, and a runner’s high that lasts long after the finish line. Every step is a victory.</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/woman-2260736_1280.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Strength Training for Patients with Injury</h3>
                <p className='coursecardDetails'>Recovery doesn’t mean retreat—it means rebuilding. This specialized Strength Training program 
                  is designed for individuals recovering from injury, surgery, or chronic conditions. With physiotherapist-approved techniques 
                  and gentle progression, we help you regain strength, stability, and confidence—without risking re-injury. Every rep is a reclaiming 
                  of power.</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/physiotherapist-helping-young-female-patient.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Physiotherapist</h3>
                <p className='coursecardDetails'>Healing begins with understanding. Our certified physiotherapists combine clinical expertise with 
                  compassionate care to help you recover from injury, manage pain, and restore mobility. Whether you're dealing with chronic discomfort 
                  or post-surgical rehab, we design personalized treatment plans that rebuild your strength and confidence. Every session is a step 
                  toward freedom—freedom to move, live, and thrive.</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/yoga-4732209_1280.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Yoga</h3>
                <p className='coursecardDetails'>Balance your body, calm your mind, and awaken your spirit. Our Yoga classes blend breathwork, 
                  movement, and mindfulness to create a sanctuary of strength and serenity. Whether you're seeking flexibility, stress relief, 
                  or spiritual connection, each pose invites you to explore your inner landscape. Come as you are—leave renewed.</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/meditating-woman-6714008_1280.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Mindfulness & Meditation</h3>
                <p className='coursecardDetails'>In a world that moves fast, learn to pause. Our Mindfulness & Meditation sessions offer tools to 
                  quiet the noise, reduce stress, and reconnect with your inner self. Through guided practices, breathwork, and stillness, you'll 
                  cultivate clarity, compassion, and emotional strength. It’s not about escaping life—it’s about embracing it fully.</p>
              </div>
            </div>            
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/massage-2768833_1280.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Deep Tissue Massage</h3>
                <p className='coursecardDetails'>Go beyond relaxation—our Deep Tissue Massage targets the knots, tension, and stress buried deep 
                  within your muscles. Ideal for athletes, desk warriors, and anyone carrying the weight of the world, this therapy improves circulation, 
                  reduces inflammation, and accelerates recovery. Feel your body realign, your breath deepen, and your energy return. It’s not just a 
                  massage—it’s a reset.</p>
              </div>
            </div>
            {/* <div className='coursescrollcard'>
              <img className='courseimg' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Name9</h3>
                <p className='coursecardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Name10</h3>
                <p className='coursecardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Name11</h3>
                <p className='coursecardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div>
            <div className='coursescrollcard'>
              <img className='courseimg' src='/images/medical-assistant-preparing-physiotherapy-exercises.jpg' alt='Models2' />
              <div className='courseintro'>
                <h3 className='coursecardName'>Name12</h3>
                <p className='coursecardDetails'>Details of the Doctor/Couch</p>
              </div>
            </div> */}
          </div >
        </div>
        <div className='about_Container4'>
          <div className='box7'>
            <img className='jdi' src='/images/background5.jpg' alt='Models1' />
          </div>
          <div className='box6'>
            <div class="pagetitle">ready to get started</div>
            <div class="discription">
              Never be bored by your fitness program again!<br></br><br></br>
              Membership is only $29.99/mo, that’s less than $1 a day!
            </div>
            <div className='button'>Join Now</div>
          </div>
        </div>
      </div>
    </div>
  );
}